/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User language for RequestHelp
 */
export type RequestLanguage = 'DE' | 'FR' | 'IT' | 'EN';

export const RequestLanguage = {
    De: 'DE' as RequestLanguage,
    Fr: 'FR' as RequestLanguage,
    It: 'IT' as RequestLanguage,
    En: 'EN' as RequestLanguage
};

